import { Divider, Tooltip } from "antd";
import t from "../../../../app/i18n";
import ActionTextIcon from "../../../../common/components/icons/ActionTextIcon";
import { ClientFormStage } from "../../enums";
import styles from "./ClientActionsFormLabel.module.scss";

interface Props {
  label: React.ReactNode;
  stage?: ClientFormStage;
  optional?: boolean;
  deleteActionType?: "delete" | "deselect";
  onCreateClick: () => void;
  onUpdateClick: () => void;
  onDeleteClick?: () => void;
}

const ClientActionsFormLabel = ({ label, stage, optional, deleteActionType, ...props }: Props) => {
  let actions = undefined;
  switch (stage) {
    case ClientFormStage.EMPTY:
      actions = props.onDeleteClick && (
        <Tooltip title={t("client.actions.deleteClient")}>
          <span>
            <ActionTextIcon icon="close" color="red" onClick={props.onDeleteClick} />
          </span>
        </Tooltip>
      );
      break;
    case ClientFormStage.NEW:
      actions = (
        <Tooltip title={t("client.actions.createClient")}>
          <span>
            <ActionTextIcon icon="user-add" color="green" onClick={props.onCreateClick} />
          </span>
        </Tooltip>
      );
      break;
    case ClientFormStage.EXISTING:
    case ClientFormStage.SELECTED:
      actions = (
        <>
          <Tooltip title={t("client.actions.updateClient")}>
            <span>
              <ActionTextIcon icon="edit" color="blue" onClick={props.onUpdateClick} />
            </span>
          </Tooltip>
          {props.onDeleteClick && (
            <>
              <Divider orientation="vertical" />
              <Tooltip
                title={
                  deleteActionType === "delete" ? t("client.actions.deleteClient") : t("client.actions.deselectClient")
                }
              >
                <span>
                  <ActionTextIcon icon="close" color="red" onClick={props.onDeleteClick} />
                </span>
              </Tooltip>
            </>
          )}
        </>
      );
      break;
  }

  return (
    <span className={styles.label}>
      <span className={!optional ? styles.requiredItem : styles.labelBox}>{label}</span>
      <div className={styles.actions}>{actions}</div>
    </span>
  );
};

export default ClientActionsFormLabel;
